export enum TransactionStatus {
  InProgress = 1,
  Completed,
  Failed,
  CompletedWithErrors,
  Resolved,
  Retried,
}



export function getStatusIconClassName(status: string) {
  return getStatusIconClassNameByStatusId(TransactionStatus[status]);

}
 

export function getStatusIconClassNameByStatusId(status: TransactionStatus) {
  if (status == TransactionStatus.Failed || status == TransactionStatus.CompletedWithErrors)
    return "fa fa-exclamation-triangle text-danger";

  if (status == TransactionStatus.Completed )
    return "fa fa-check text-success";

  if (status ==  TransactionStatus.InProgress )
    return "fa fa-sync text-primary";

  if (status ==  TransactionStatus.Resolved )
    return "fal fa-clipboard-check text-success";
  return "";
}

export function getStatusTextClassName(status: string) {
  return getTransactionStatusClass(TransactionStatus[status]);
}

export function getTransactionStatusClass(status: TransactionStatus) {
  if (status == TransactionStatus.Failed)
    return "text-danger";

  if (status == TransactionStatus.Completed)
    return "";

  if (status == TransactionStatus.InProgress)
    return "";

  return "";
} 

export function getTransactionStatusText(entity:string, status: TransactionStatus) {
  if (status == TransactionStatus.Failed)
    return `${entity} failed to run.`;

  if (status == TransactionStatus.InProgress)
    return `${entity} running ...`;

  if (status == TransactionStatus.CompletedWithErrors)
    return `${entity} completed with errors.`;

  if (status == TransactionStatus.Completed)
    return `${entity} completed.`;

  return "";
}
